module.exports = __webpack_public_path__ + "img/infography-md.8a49a7ae.webp";